import { faSpinner } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useContext, useEffect, useState } from "react"
import { Navigate } from "react-router-dom"
import Authentication from "../../../../../libs/api/services/Authentication"
import Patient from "../../../../../libs/api/services/Patient"
import CommonFunctionsContext from "../../../../common/CommonFunctionsProvider"
import PatientContext from "../PatientProvider"
import PatientProfileContainerResponsive from "./PatientProfileContainerResponsive"

export default function PatientProfileResponsive({ isOwn, profile, onSaved, setProfile }) {
    const [categories, setCategories] = useState([])
    const [saving, setSaving] = useState(false)
    const { showToast, showError } = useContext(CommonFunctionsContext)
    const { activePatient, SetActivePatient } = useContext(PatientContext)

    useEffect(() => {
        const _load = async () => {
            const _categories = await Patient.Categories(isOwn)
            setCategories(_categories)
        }
        _load()
    }, [isOwn])
    // }, [profile, isOwn])


    const _reloadProfile = async (newProfileId, redir) => {
        if (!profile.id) {
            onbeforeunload = (event) => { event.preventDefault(); return false; };
            if (!onSaved) Navigate('/Dashboard/Patient/' + newProfileId)
        } else
            setProfile(await Patient.LoadPatient(newProfileId))
    }

    const _handleSave = async (redir) => {
        setSaving(true)
        showToast('Saving changes', undefined, 3)
        var _profile = profile

        if (!_profile.id) {
            _profile = await Patient.InitNewPatient(Authentication.getFacility())
        }

        var details = []
        for (var d in profile.profiles) {
            details.push(
                {
                    Detail: profile.profiles[d].detail,
                    DetailsType: {
                        Id: profile.profiles[d].detailsType.id
                    }
                }
            )
            // await Patient.SetPatientProfileDetail(profile.profiles[d].detailsType.id, profile.profiles[d].detail, _profile.id)
        }
        // console.log('_handleSave 2', details)
        if (await Patient.SetPatientProfileDetailBulk(details, _profile.id).catch((e) => showError(e))) {
            // console.log('_handleSave 3')
            SetActivePatient(_profile.id)
            if (onSaved) onSaved(_profile)
            // setVersion(0)
            // setSticky(false)
            onbeforeunload = (event) => { return }
            _reloadProfile(_profile.id, redir)
            showToast('Profile changes saved', undefined, 3)

        }
        setSaving(false)
    }
    const _handleSetValue = (i, v) => {
        // setVersion(2)
        var _profile = { ...profile }
        var _detail = _profile.profiles.find(p => p.detailsType.id === i)
        if (!_detail) {
            _profile.profiles.push({ detailsType: { id: i }, detail: v })
        } else {
            // Update
            _detail.detail = v
        }
        setProfile({ ..._profile })
    }
    return (categories && categories.length > 0 &&
        <>
            {
                categories.map(cat => cat && cat.resource && <>
                    <div key={cat.resource.id} style={{ top: '0px', position: 'sticky', zIndex: 100 }} className="bg-primary-container d-lg-none p-2 text-center">{cat.resource.groupNme}</div>
                    <div className="d-flex d-lg-none flex-column">
                        <PatientProfileContainerResponsive
                            isOwn={isOwn}
                            onSaved={() => { }}
                            setProfile={setProfile}
                            category={cat.resource}
                            profile={profile}
                            _handleSave={_handleSave}
                            categoryId={cat.resource.id} />
                    </div>
                </>)
            }
            <div className=' w-100 text-center p-3 d-lg-none' style={{ position: 'sticky', bottom: '30px', zIndex: 111 }}>
                {!saving ? <button
                    type='submit'
                    onClick={() => _handleSave()}
                    className='btn bg-primary-container'>Save</button>
                    : <div><FontAwesomeIcon icon={faSpinner} spin /> Saving</div>}
            </div>
        </>
    )
}

// const PatientResponsiveDetails = ({ categoryId }) => {
//     return <div style={{ paddingBottom: '300px' }}>{categoryId}</div>
// }